export default __webpack_public_path__ + "static/media/try-atomic-diet-form.dbe70f86.png";